import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams, TenderIdParams } from 'types/api'
import { ITenderEvaluations } from 'types/tender/tenderEvaluations'

export const tenderEvaluationApi = createApi({
  reducerPath: 'tenderEvaluation',
  baseQuery,
  tagTypes: ['TenderEvaluations'],
  endpoints: (builder) => ({
    tenderEvaluations: builder.query<ITenderEvaluations, TenderIdParams>({
      query: ({ tenderId }) => ({
        url: '/tender-evaluation',
        params: {
          tenderId,
        },
      }),
      providesTags: ['TenderEvaluations'],
    }),

    tenderEvaluation: builder.query<ITenderEvaluations, IdParams>({
      query: ({ id }) => `/tender-evaluation/${id}`,
    }),

    createTenderEvaluation: builder.mutation<
      ITenderEvaluations,
      Partial<ITenderEvaluations>
    >({
      query: (body) => ({
        url: `tenders/${body.tenderId}/evaluation`,
        body,
        method: 'post',
      }),
    }),

    confirmTenderEvaluation: builder.mutation<
      ITenderEvaluations,
      Partial<ITenderEvaluations>
    >({
      query: (body) => ({
        url: `/tenders/${body.tenderId}/evaluation/confirm`,
        body,
        method: 'post',
      }),
    }),
    restartTenderEvaluation: builder.mutation<
      ITenderEvaluations,
      Partial<ITenderEvaluations>
    >({
      query: (body) => ({
        url: `/tenders/${body.tenderId}/evaluation/restart`,
        body,
        method: 'post',
      }),
    }),
    submitTenderEvaluation: builder.mutation<
      ITenderEvaluations,
      Partial<ITenderEvaluations>
    >({
      query: (body) => ({
        url: `/tenders/${body.tenderId}/evaluation/submit`,
        body,
        method: 'post',
      }),
    }),
  }),
})

export const {
  useConfirmTenderEvaluationMutation,
  useRestartTenderEvaluationMutation,
  useSubmitTenderEvaluationMutation,
  useCreateTenderEvaluationMutation,
  useTenderEvaluationQuery,
  useTenderEvaluationsQuery,
} = tenderEvaluationApi
